import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { CashRegister } from '@models/cashRegister.interface';
import { BaseHttpService } from '@core/services/base-http.service';

@Injectable()
export class CashRegisterService extends BaseHttpService<CashRegister> {
  constructor(http: HttpClient) {
    super(http, 'cashRegister');
  }
}
